import { render, staticRenderFns } from "./ManifestPublic.vue?vue&type=template&id=4833519f&"
import script from "./ManifestPublic.vue?vue&type=script&lang=js&"
export * from "./ManifestPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports